import { render, staticRenderFns } from "./FullNewsList.vue?vue&type=template&id=a6c92542&scoped=true&"
import script from "./FullNewsList.vue?vue&type=script&lang=js&"
export * from "./FullNewsList.vue?vue&type=script&lang=js&"
import style0 from "./FullNewsList.vue?vue&type=style&index=0&id=a6c92542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c92542",
  null
  
)

export default component.exports